import * as React from 'react';
import { lazy, Suspense, useEffect } from 'react';
import { Switch, Route, useLocation, Redirect } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Loader from './layout/Loader';
import ScrollToTop from './layout/ScrollToTop';
import routesOnePage from '../route';
import routes from '../routes';
import Config from '../config';
import '../../node_modules/font-awesome/scss/font-awesome.scss';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';
import { appLogout } from '../store/property/common/commonProperty.actions';
import Swal from 'sweetalert2';
import { initialLoadCommon } from './components/Common/Util';
import Cookies from 'js-cookie';
import VendorManagement from '../screens/VendorManagement';
import { PROGRAM_WISE_REPORT_RESET } from '../store/programs/YarnPO/yarnPO/yarnPO.actionsType';
import { useHistory } from 'react-router-dom';


const AdminLayout = lazy(() => import('./layout/AdminLayout'));
const App = () => {
    const location = useLocation();
    let dispatch = useDispatch();
    const history = useHistory();


    // const storedLoginRef = React.useRef(null);
    // useEffect(() => {
    //     // Store initial login data on mount
    //     const initialLogin = JSON.parse(localStorage.getItem('Login'));
    //     storedLoginRef.current = initialLogin;

    //     const checkLoginChangeAndRefresh = () => {
    //         const currentLogin = JSON.parse(localStorage.getItem('Login'));

    //         const hasChanged =
    //             JSON.stringify(currentLogin) !== JSON.stringify(storedLoginRef.current);

    //         if (hasChanged) {
    //             window.location.reload();
    //         }
    //     };

    //     window.addEventListener('focus', checkLoginChangeAndRefresh);

    //     return () => {
    //         window.removeEventListener('focus', checkLoginChangeAndRefresh);
    //     };
    // }, []);

    // useEffect(() => {
    //     const token = localStorage.getItem('Login');
    //     if (!token) {
    //         history.push('/auth/loginV2'); // Just redirect
    //     }
    // }, []);


    const handleKeyPress = React.useCallback((event) => {
        // Check if the pressed key matches your desired shortcut
        if (event.key === 'Enter' && event.ctrlKey) {
            // Execute your functionality here
            console.log('Shortcut key pressed: Ctrl + Enter');

            Swal.fire({
                html: '<i class="fas fa-spinner fa-spin"></i><p>Please Wait Your Data is Processing...</p>',
                // icon: 'success',
                text: 'Please Wait...',
                allowOutsideClick: false,
                showConfirmButton: false
            });
        }
    }, []);



    // useEffect(() => {
    //     // Add event listener when component mounts
    //     window.addEventListener('keydown', handleKeyPress);

    //     // Remove event listener when component unmounts
    //     return () => {
    //         window.removeEventListener('keydown', handleKeyPress);
    //     };
    // }, [handleKeyPress]);

    // Set the idle timeout (in milliseconds)
    const idleTimeout = 20 * 60 * 1000; // 20 minutes

    useEffect(() => {
        let logoutTimer;

        // Function to log the user out
        const logout = () => {
            // Perform the logout action, e.g., redirect to the login page
            console.log('User has been logged out due to inactivity.');
            dispatch(appLogout());
        };

        // Start the idle timer
        const startIdleTimer = () => {
            logoutTimer = setTimeout(logout, idleTimeout);
        };

        // Reset the idle timer whenever there is user activity
        const resetIdleTimer = () => {
            clearTimeout(logoutTimer);
            startIdleTimer();
        };

        // Attach event listeners to reset the timer on user activity
        window.addEventListener('mousemove', resetIdleTimer);
        window.addEventListener('keydown', resetIdleTimer);

        // Start the initial idle timer
        startIdleTimer();

        let token = Cookies.get('JWT_TOKEN')

        // console.log('token', token)

        if (token) {
            window.onload = initialLoadCommon(dispatch)
        }


        // Clean up event listeners and timers when the component unmounts
        return () => {
            window.removeEventListener('mousemove', resetIdleTimer);
            window.removeEventListener('keydown', resetIdleTimer);
            clearTimeout(logoutTimer);
        };
    }, []);

    useEffect(() => {
        if (location.pathname !== '/program-wise-report' && location.pathname !== '/epro-invoice') {
            localStorage.removeItem('SummaryDataGridState');
            localStorage.removeItem('DetailedGridState');
            dispatch({ type: PROGRAM_WISE_REPORT_RESET })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location])

    return (
        <>
            <ScrollToTop>
                <Suspense fallback={<Loader />}>
                    <Route path={routesOnePage.map((x) => x.path)}>
                        <Switch location={location} key={location.pathname}>
                            {routesOnePage.map((route, index) => {
                                return route.component ? (
                                    <Route
                                        key={index}
                                        path={route.path}
                                        exact={route.exact}
                                        render={(props) => <route.component {...props} />}
                                    />
                                ) : null;
                            })}
                        </Switch>
                    </Route>
                    <Route path={routes.map((x) => x.path)}>
                        <AdminLayout />
                    </Route>

                    {/* 
                    <Route path={'/vendor-management/:id'}>
                        <VendorManagement />
                    </Route> */}

                    <Route path={'/'} exact>
                        <Redirect to={Config.defaultPath} />
                    </Route>
                </Suspense>
                <ToastContainer position="top-right" />
            </ScrollToTop>
            <div className="backdrop" />
        </>
    );
};
export default App;
